import { Col, Typography } from "antd";

import { IMG_PATH } from "../../constants/assets";
import { CONTACT_CONTENT } from "../../constants/content/pages/contact";

import CustomRow from "../../shared/costum-row/costum-row";
import CustomImage from "../../shared/custom-image/custom-image";
import FooterLinks from "./components/footer-links/footer-links";
import Newsletter from "./components/newsletter/newsletter";
import SocialLinks from "./components/social-links/social-links";
import Address from "./components/address/address";

import "./styles.scss";
import { FOOTER_LOGO } from "../../constants/svgs";
import useBreakpoints from "../../hooks/use-breakpoints";
import { BREAKPOINTS } from "../../constants/styles";
import useScreenResolution from "../../hooks/use-screen-resolution";

const { Text } = Typography;

const Footer = () => {
  const { width } = useScreenResolution();

  const isSmallScreen = width <= BREAKPOINTS.SMALL_DESKTOP.resolution;
  const isMobile = width <= BREAKPOINTS.MOBILE.resolution;

  let logo = FOOTER_LOGO.LARGE;

  if (isMobile) {
    logo = FOOTER_LOGO.SMALL;
  } else if (isSmallScreen) {
    logo = FOOTER_LOGO.MEDIUM;
  }

  return (
    <div className="Footer">
      <CustomRow justify="space-between">
        <Col xxl={4} xl={4} lg={6} md={6} sm={24} xs={24}>
          <FooterLinks />
        </Col>
        <Col xxl={8} xl={8} lg={12} md={12} sm={24} xs={24}>
          <Newsletter />
        </Col>
      </CustomRow>
      <CustomRow justify="space-between">
        <Col xxl={4} xl={4} lg={6} md={6} sm={4} xs={4}>
          <SocialLinks />
        </Col>
        <Col xxl={8} xl={8} lg={12} md={12} sm={8} xs={12}>
          <Address />
        </Col>
      </CustomRow>
      <CustomRow justify="space-between">
        <Col xxl={4} xl={4} lg={6} md={6} sm={24} xs={24}>
          {logo}
        </Col>
        <Col
          xxl={8}
          xl={8}
          lg={12}
          md={12}
          sm={24}
          xs={24}
          className="Footer-copyright"
        >
          <Text className="Footer-copyright-text">
            {CONTACT_CONTENT.footer.copyright}
          </Text>
        </Col>
      </CustomRow>
    </div>
  );
};

export default Footer;
